import React from 'react'
import HomePoster from './HomePoster'
import VisionPoints from './VisionPoints'
import Subscribe from './Subscribe'
import HomeCards from "./HomeCards";
import MissionStatement from "./MissionStatement";

const Home = () => {



    return (
        <>
            <HomePoster />
            <MissionStatement />
            <HomeCards />
            <VisionPoints />
            <Subscribe />
        </>
    )
}

export default Home
